/*
  Основание управления домом: как оно читается в таблице и как правится.

  Отделено от `CourtBuildings.jsx` 15.09.2026: список домов и форма правки
  реквизитов - разные ответственности, и вместе они подвели компонент к пределу
  размера (§8.7). Здесь нет ни одного запроса: форма отдаёт готовые значения
  наверх, грузит и сохраняет `SettingsCourtSections`.

  Зачем это на экране вообще. Заявление начинается с абзаца о том, чем
  подтверждается право требовать плату, и без протокола общего собрания не
  формируется вовсе (решение владельца 14.09.2026, уточнено 23.09.2026:
  основанием служит только протокол, договор управления хранится справочно).
  Значит, пробел обязан быть виден в справочнике, а не всплыть отказом в день
  сборки волны.
*/

import { useState } from 'react'

import { date } from '../api/format.js'
import { Field } from './Common.jsx'

export function basisText(building) {
  const parts = []
  if (building.protocol_number || building.protocol_date) {
    const number = building.protocol_number ? `протокол № ${building.protocol_number}` : 'протокол'
    parts.push(building.protocol_date ? `${number} от ${date(building.protocol_date)}` : number)
  }
  // Договор помечен «справочно»: в заявление он не печатается с 23.09.2026, и
  // строка без пометки читалась бы как основание, которого больше нет.
  if (building.contract_date) {
    parts.push(`договор управления от ${date(building.contract_date)} (справочно)`)
  }
  return parts.join(', ')
}

export function BasisForm({ building, onSave, onCancel }) {
  const [values, setValues] = useState({
    protocol_number: building.protocol_number ?? '',
    protocol_date: building.protocol_date ?? '',
    contract_date: building.contract_date ?? '',
  })
  const [full, setFull] = useState(building.full_address ?? '')
  const [busy, setBusy] = useState(false)

  return (
    <form
      className="row"
      onSubmit={async (event) => {
        event.preventDefault()
        setBusy(true)
        await onSave(withFullAddress(asBody(values), full, building.full_address))
        setBusy(false)
      }}
    >
      {/*
        Полный адрес дома - с 01.10.2026: он печатается в заявлении вместо
        записи выгрузки. Домам, заведённым раньше без населённого пункта, он
        вносится здесь, без отвязки - вместе с привязкой потерялась бы
        подсудность.
      */}
      <Field label={`Полный адрес: ${building.address}`} width="l">
        <input
          className="field__input"
          value={full}
          onChange={(event) => setFull(event.target.value)}
          placeholder={`г. Кемерово, ${building.address}`}
        />
      </Field>
      <Field label={`Основание управления: ${building.address}`} width="s">
        <input
          className="field__input"
          value={values.protocol_number}
          onChange={(event) => setValues({ ...values, protocol_number: event.target.value })}
          placeholder="протокол №"
        />
      </Field>
      <Field label="Дата протокола" width="s">
        <input
          className="field__input"
          type="date"
          value={values.protocol_date}
          onChange={(event) => setValues({ ...values, protocol_date: event.target.value })}
        />
      </Field>
      <Field label="Дата договора управления" width="s">
        <input
          className="field__input"
          type="date"
          value={values.contract_date}
          onChange={(event) => setValues({ ...values, contract_date: event.target.value })}
        />
      </Field>
      <button className="button" type="submit" disabled={busy}>
        Сохранить
      </button>
      <button className="button button--quiet" type="button" onClick={onCancel}>
        Отмена
      </button>
    </form>
  )
}

/*
  Полный адрес уходит на сервер, только если его изменили: сервер с 01.10.2026
  не трогает то, что не прислано, и правка одного протокола не должна заново
  проверять - а то и стирать - адрес, которого человек не касался.
*/
export function withFullAddress(body, typed, saved) {
  const next = typed.trim()
  return next === (saved ?? '') ? body : { ...body, full_address: next || null }
}

export function asBody(values) {
  return {
    protocol_number: values.protocol_number.trim() || null,
    protocol_date: values.protocol_date || null,
    contract_date: values.contract_date || null,
  }
}
